import { Button, HStack } from "@chakra-ui/react";

interface NavigationProps {
  back?: (data?: any) => Promise<void> | void;
  next?: (data?: any) => Promise<void> | void;
  nextLabel?: string;
  backLabel?: string;
  canBack?: boolean;
  canNext?: boolean;
  isLoading?: boolean;
}

export const Navigation = ({
  back,
  next,
  nextLabel = "Next",
  backLabel = "Back",
  canBack = true,
  canNext,
  isLoading,
}: NavigationProps) => (
  <HStack w="full" justifyContent={"flex-end"}>
    {back ? (
      <Button
        variant={"outline"}
        onClick={back}
        isDisabled={!canBack && !isLoading}
        isLoading={isLoading}
    >
        {backLabel}
      </Button>
    ) : null}
    {next ? (
      <Button
        colorScheme={"green"}
        onClick={next}
        isDisabled={!canNext && !isLoading}
        isLoading={isLoading}
      >
        {nextLabel}
      </Button>
    ) : null}
  </HStack>
);

export default Navigation;
